// extracted by css-extract-rspack-plugin
export default {"ToolbarButtonSkeleton":"ToolbarButtonSkeleton-module__ToolbarButtonSkeleton__n6wqW"};